import { Stack } from '@mui/material'
import { RatingType } from '../../../components/matchmaking/ChallengeCard'
import { useScreenSize } from '../../../hooks/useScreenSize'
import StatsContainer from '../../Profile/components/StatsContainer'
import StatsTable from '../../Profile/components/StatsTable'

// utter junk code to make stats workable
export const StatsWrapper = () => {
    const { isMobile } = useScreenSize()
    const ratingTypes: RatingType[] = ['bullet', 'blitz', 'rapid', 'classic']

    if (isMobile)
        return (
            <Stack
                sx={{
                    gap: 1,
                    width: '100%',
                    'div, li': {
                        borderRadius: '0px',
                        margin: 0,
                    },
                    li: {
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                    },
                }}
            >
                {ratingTypes.map((ratingType, index) => (
                    <StatsContainer key={index} ratingType={ratingType} />
                ))}
            </Stack>
        )

    return <StatsTable />
}
